import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { ProjectWithAssigneesDto } from '../../../commonTypes/acs';
import { setCachedSingleProject, selectCachedSingleProject } from '../../../store/slices/projects.slice';

const useHttpGetProjectWithClientUserBranch = (id: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const toastHandler = useContainer(ToastStateHandler);
    const dispatch = useDispatch();
    const { t } = useTranslation('newNotifications');

    const cachedProject = useSelector(selectCachedSingleProject(id));

    const [isReady, setIsReady] = useState(false);
    const [project, setProject] = useState<ProjectWithAssigneesDto | undefined>(cachedProject);

    const getProjects = (assigneeStatus?: string, forceRefresh = false) => {
        if (!id) {
            setIsReady(true);
            return;
        }

        if (!forceRefresh && !assigneeStatus && cachedProject) {
            setProject(cachedProject);
            setIsReady(true);
            return;
        }

        const { exec, abort } = acsApi.getProjectWithClientUserBranch({
            params: { id },
            query: { assigneeStatus },
            onSuccess: res => {
                dispatch(setCachedSingleProject(res.body));
                setProject(res.body);
            },
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (!id) {
            setIsReady(true);
            return;
        }

        if (cachedProject) {
            setProject(cachedProject);
            setIsReady(true);
            return;
        }

        getProjects();
    }, [id, cachedProject]);

    return { isReady, project, setProject, getProjects };
};

export default useHttpGetProjectWithClientUserBranch;
